export default "__VITE_ASSET__Di1SKI1g__"